class ProductBuy extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.footerVisible = false
    this.setupListeners()
    this.checkLocationTrigger()
  }

  setupListeners () {
    super.setupListeners()

    this.footerObserver = new IntersectionObserver(
      this.onFooterIntersect.bind(this),
      {
        root: null,
        rootMargin: '0px',
        threshold: 0,
      },
    )

    if (this.externalEls.footer.element) {
      this.footerObserver.observe(this.externalEls.footer.element)
    }

    this.checkLocationTrigger = this.checkLocationTrigger.bind(this)

    this.onTriggerClick = this.onTriggerClick.bind(this)

    this.els['hover-trigger'].elements.forEach((el) => {
      if (el.hasAttribute('data-drawer-trigger')) {
        this.listeners.add(el, 'click', (event) => this.onTriggerClick(event))
      }
    })

    this.onPayWhatYouFeelProductOption =
      this.onPayWhatYouFeelProductOption.bind(this)

    this.els?.subscriptionOption?.elements.forEach((el) => {
      this.listeners.add(el, 'click', (event) =>
        this.onPayWhatYouFeelProductOption(event),
      )
    })

    this.onPayWhatYouFeelProductOptionBack =
      this.onPayWhatYouFeelProductOptionBack.bind(this)

    this.els?.back?.elements.forEach((el) => {
      this.listeners.add(el, 'click', (event) =>
        this.onPayWhatYouFeelProductOptionBack(event),
      )
    })

    this.onCloseClick = this.onCloseClick.bind(this)

    this.els.close.elements.forEach((el) => {
      this.listeners.add(el, 'click', this.onCloseClick)
    })

    this.onBackdropClick = this.onBackdropClick.bind(this)

    this.els.backdrop.elements.forEach((el) => {
      this.listeners.add(el, 'click', this.onBackdropClick)
    })

    if (
      window.yotpoWidgetsContainer &&
      window.yotpoWidgetsContainer.yotpo_event_bus &&
      typeof window.yotpoWidgetsContainer.yotpo_event_bus.subscribe ===
        'function'
    ) {
      window.yotpoWidgetsContainer.yotpo_event_bus.subscribe(
        'v1/product_price_changed',
        () => {
          this.onVariantChanged()
        },
      )
    }

    if (!window.BAO.MediaBreakpoints.isSm) return

    this.onMouseEnter = this.onMouseEnter.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)
    this.onTargetMouseEnter = this.onTargetMouseEnter.bind(this)
    this.onTargetMouseLeave = this.onTargetMouseLeave.bind(this)

    this.hoveringOverTarget = false

    this.els['hover-trigger'].elements.forEach((el) => {
      this.listeners.add(el, 'mouseenter', this.onMouseEnter)
      this.listeners.add(el, 'mouseleave', this.onMouseLeave)
    })

    this.els['hover-target'].elements.forEach((el) => {
      this.listeners.add(el, 'mouseenter', this.onTargetMouseEnter)
      this.listeners.add(el, 'mouseleave', this.onTargetMouseLeave)
    })
  }

  checkLocationTrigger () {
    if (window.location.search.includes('?open-buy-options')) {
      this.els['hover-trigger'].elements.forEach((el) => {
        if (el.hasAttribute('data-drawer-trigger')) {
          el.click()
        }
      })
    }

    if (window.location.search.includes('?variant=')) {
      const subscriptionOption = this.els.subscriptionOption.element
      const subscriptionOptionId =
        subscriptionOption.getAttribute('data-variant-id')

      if (window.location.search.includes(`?variant=${subscriptionOptionId}`)) {
        this.onPayWhatYouFeelProductOption()

        const backButton = this.els?.back?.element
        backButton.setAttribute(
          'data-current-variant-subscription-option',
          'true',
        )
      }
    }
  }

  onFooterIntersect (entries) {
    entries.forEach((entry) => {
      // If any part of the footer is visible or we've scrolled past it
      if (entry.isIntersecting || entry.boundingClientRect.bottom < 0) {
        this.footerVisible = true
      } else {
        this.footerVisible = false
      }

      if (this.footerVisible) {
        document.body.classList.remove(this.dataset.visibleClass)
      } else {
        document.body.classList.add(this.dataset.visibleClass)
      }
    })
  }

  onTriggerClick (event) {
    this.currentProductType =
      event.currentTarget.getAttribute('data-product-type')

    const sellingPlanElements = Array.from(
      document.querySelectorAll('[data-seling-plan-group-id]'),
    )
    const uniqueElements = sellingPlanElements.filter(
      (element, index, self) =>
        index ===
        self.findIndex(
          (e) =>
            e.getAttribute('data-seling-plan-group-id') ===
            element.getAttribute('data-seling-plan-group-id'),
        ),
    )

    let isSubscription = true
    const match = uniqueElements.find(
      (el) =>
        el.getAttribute('data-seling-plan-group-id') ===
        this.currentProductType,
    )

    if (match) {
      match.click()
      isSubscription = false
    } else {
      const fallbackElement = uniqueElements.find(
        (el) => el.getAttribute('data-seling-plan-group-id') !== 'buy-once',
      )

      if (fallbackElement) {
        fallbackElement.click()
      }
    }

    if (this.dataset.giftCard === 'true') {
      isSubscription = false
    }

    this.showComponent(isSubscription)
    this.els.drawer.element.show()
    this.classList.add(this.activeClass)
  }

  onVariantChanged () {
    if (this.currentProductType === 'buy-once') {
      const buyOnceElement = document.querySelector(
        '[data-seling-plan-group-id="buy-once"]',
      )

      buyOnceElement.click()
    }
  }

  showComponent (isSubscription) {
    this.setAttribute('data-subscription', isSubscription)
  }

  onPayWhatYouFeelProductOption (event) {
    const closeButton = this.els?.close?.element
    const backButton = this.els?.back?.element

    closeButton.setAttribute('aria-hidden', 'true')
    backButton.setAttribute('aria-hidden', 'false')

    const bodyDrawer = this.querySelector('.drw-Drawer_Body')
    if (
      bodyDrawer &&
      bodyDrawer.getAttribute('data-current-variant-back-triggered') === 'true'
    ) {
      bodyDrawer.removeAttribute('data-current-variant-back-triggered')
    }
  }

  onPayWhatYouFeelProductOptionBack () {
    const closeButton = this.els?.close?.element
    const backButton = this.els?.back?.element

    closeButton.setAttribute('aria-hidden', 'false')
    backButton.setAttribute('aria-hidden', 'true')

    this.deselectVariant()

    if (
      backButton.getAttribute('data-current-variant-subscription-option') ===
      'true'
    ) {
      this.onPayWhatYouFeelProductOptionBackHideYotpo()
    }
  }

  onPayWhatYouFeelProductOptionBackHideYotpo () {
    const closeButton = this.els?.close?.element
    const backButton = this.els?.back?.element

    closeButton.setAttribute('aria-hidden', 'false')
    backButton.setAttribute('aria-hidden', 'true')

    const bodyDrawer = this.querySelector('.drw-Drawer_Body')

    bodyDrawer.setAttribute('data-current-variant-back-triggered', 'true')
  }

  onCloseClick (event) {
    const drawer = event.currentTarget.closest(
      '[data-product-buy-el="drawer"]',
    )

    drawer.close()

    this.classList.remove(this.activeClass)
    event.currentTarget.classList.remove(this.activeClass)

    this.deselectVariant()
  }

  onBackdropClick () {
    this.els.drawer.elements.forEach((el) => {
      el.close()
    })

    this.classList.remove(this.activeClass)
    this.classList.remove(this.hoverClass)
    this.deselectVariant()
    this.onPayWhatYouFeelProductOptionBackHideYotpo()
  }

  deselectVariant () {
    const variantRadio = document.querySelector(
      '[data-variant-radios-el="option-choice"]:checked',
    )
    if (variantRadio) {
      variantRadio.checked = false

      const event = new Event('change')
      this.els['variant-radios'].element.dispatchEvent(event)
    }
  }

  onMouseEnter (event) {
    const trigger = event.currentTarget
    const triggerDataAttr = trigger.getAttribute('data-hover-target')

    this.els['hover-target'].elements.forEach((targetEl) => {
      const targetDataAttr = targetEl.getAttribute('data-hover-target')

      if (targetDataAttr === triggerDataAttr) {
        targetEl.setAttribute('aria-hidden', 'false')
        this.classList.add(this.hoverClass)
      }
    })
  }

  onMouseLeave (event) {
    const trigger = event.currentTarget
    const triggerDataAttr = trigger.getAttribute('data-hover-target')

    setTimeout(() => {
      if (!this.hoveringOverTarget) {
        this.els['hover-target'].elements.forEach((targetEl) => {
          const targetDataAttr = targetEl.getAttribute('data-hover-target')

          if (targetDataAttr === triggerDataAttr) {
            targetEl.setAttribute('aria-hidden', 'true')
            this.classList.remove(this.hoverClass)
          }
        })
      }
    }, 100)
  }

  onTargetMouseEnter (event) {
    this.hoveringOverTarget = true
    const target = event.currentTarget
    target.setAttribute('aria-hidden', 'false')
    this.classList.add(this.hoverClass)
  }

  onTargetMouseLeave (event) {
    this.hoveringOverTarget = false
    const target = event.currentTarget

    setTimeout(() => {
      if (!this.isHoveringTrigger(target)) {
        target.setAttribute('aria-hidden', 'true')
        this.classList.remove(this.hoverClass)
      }
    }, 100)
  }

  isHoveringTrigger (target) {
    const triggerDataAttr = target.getAttribute('data-hover-target')
    let isHovering = false

    this.els['hover-trigger'].elements.forEach((triggerEl) => {
      const triggerDataAttrEl = triggerEl.getAttribute('data-hover-target')

      if (
        triggerDataAttr === triggerDataAttrEl &&
        triggerEl.matches(':hover')
      ) {
        isHovering = true
      }
    })

    return isHovering
  }

  get hoverClass () {
    return this.dataset.hoverClass
  }

  get activeClass () {
    return this.dataset.activeClass
  }
}

if (!customElements.get('product-buy')) {
  customElements.define('product-buy', ProductBuy)
}
